import axios from "axios";

/**
 * Serviço de release notes (clarity), espelhando o clarity.service.ts do Omnyve.CPU.UI.
 * As chamadas vão para /api/release-notes*, que é repassado para a clarity pelo
 * proxy em src/setupProxy.js (dev) / servidor web (prod).
 *
 * Usa axios "puro" (sem o client() autenticado) para não enviar o token do Omnify
 * para a clarity nem disparar o interceptor global de 401/403.
 */

const RELEASE_NOTES_URL = "/api/release-notes";
const PRODUCT_NAME = "omnyve";

const clarityService = {
  getReleaseNotes: (role = "supervisor") => {
    return new Promise((resolve, reject) => {
      axios
        .get(RELEASE_NOTES_URL, {
          params: { product_name: PRODUCT_NAME, role: role },
        })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },

  getReleaseNoteFileUrl: (fileUrl) => {
    return `${RELEASE_NOTES_URL}/file?url=${encodeURIComponent(fileUrl)}`;
  },
};

export default clarityService;
